// Module
var code = `<h1>Affiliate</h1> <h3 class="metric-meaning">What does it mean?</h3><p>The traffic sent via affiliate links and promo codes, when partners get a commission for the users they bring to the site.</p> `;
// Exports
module.exports = code;